export default {
	subtitle: "Checkout Page for cards",
  path: "transaction_cc_checkoutpage_br",
	paragraphs: [
    "For Brazil we give the option to have a pre-build checkout page for you customer to pay with cards, if you do not have one yourself. Our system will generate a unique checkout URL and a corresponding checkout ID. You can share this checkout URL directly with your customers, allowing them to complete their payment through our secure payment page.",

    "Once the payment is completed, we will notify you by sending a payment confirmation to your webhook endpoint along with the checkout ID, which can be used as a reference for tracking and managing the transaction within your system. The checkout URL will remain active until a payment is successfully processed, after that the checkout page will no longer be accessible.",

    "If the payment attempt fails, we will also notify you via webhook. The checkout page will also remain active until a successful payment is made. "
  ],
  request: {
    method: "POST",
    endpoint: "/transactions/checkout",
    payload: {
      "subject_id": "customer id",
      "value": "100.00",
      "currency": "BRL",
      "exchange_currency": "BRL",
      "to_bank_account_id": "your cash-in internal account BRL or USD"
    },
    responses: {
      "data": {
        "checkout_page_url": "https://sandbox-portal.facilitapay.com/card/checkout?id=80c675cc-5a68-4023-87a3-faf13401d424",
        "id": "80c675cc-5a68-4023-87a3-faf13401d424"
      }
    }
    
  },
  parameterPayload: [
    {
      name: "subject_id",
      type: "string",
      required: true,
      description: "ID of one of the partner's customer"
    },
    {
      name: "value",
      type: "string",
      required: true,
      description: "Transaction value with two decimal places in the original currency, e.g., \"100.00\""
    },
    {
      name: "exchange_currency",
      type: "string",
      required: true,
      description: "Destination bank account currency. It can be the local currency (BRL), or international currencies (USD/EUR)"
    },
    {
      name: "to_bank_account_id",
      type: "string",
      required: true,
      description: "Id of the destination bank account. This bank account must have the same currency as the 'exchange_currency' field"
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/Transaction/CreditCardBRLCheckoutPage.js